var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CodeEditor',{attrs:{"label":this.$t('code'),"label-cols":2,"horizontal":true,"controls":["libs"],"libs":_vm.libs,"vars":_vm.vars,"snippets":_vm.snippets},model:{value:(_vm.content.expression),callback:function ($$v) {_vm.$set(_vm.content, "expression", $$v)},expression:"content.expression"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }